// istanbul ignore file
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import {
  setCurrentBreakpoint as setCurrentBreakpointAction,
  setBreakpoints as setBreakpointsAction,
  listenForBreakpointChanges as listenForBreakpointChangesAction,
  setIsMobile as setIsMobileAction,
} from '../modules';

const BreakpointProviderContainer = ({ childComponent: ChildComponent, ...props }) => (
  <ChildComponent {...props} />
);

BreakpointProviderContainer.propTypes = {
  childComponent: PropTypes.func.isRequired,
};

const mapDispatchToProps = dispatch => ({
  setCurrentBreakpoint: breakpoint => dispatch(setCurrentBreakpointAction(breakpoint)),
  setBreakpoints: breakpoints => dispatch(setBreakpointsAction(breakpoints)),
  listenForBreakpointChanges:
  ({ mobileConditionBreakpointsArray }) =>
    dispatch(listenForBreakpointChangesAction({ mobileConditionBreakpointsArray })),
  setIsMobile: isMobile => dispatch(setIsMobileAction(isMobile)),
});

export default connect(null, mapDispatchToProps)(BreakpointProviderContainer);
